import React from 'react'
import PropTypes from 'prop-types'

// Left-pointing chevron shown in the "Collapse Map" pill over the map.
function CollapseArrowIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M15 6l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Small map glyph shown in the "Expand Map" button.
function MapGlyphIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 4v14M15 6v14"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Six-dot grab handle used to drag-resize the map.
function DragDotsIcon() {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="3" cy="3" r="1.5" />
      <circle cx="9" cy="3" r="1.5" />
      <circle cx="3" cy="9" r="1.5" />
      <circle cx="9" cy="9" r="1.5" />
      <circle cx="3" cy="15" r="1.5" />
      <circle cx="9" cy="15" r="1.5" />
    </svg>
  )
}

// Floating pill rendered over the map (expanded view) to collapse the map.
export function CollapseMapButton({ onClick }) {
  return (
    <button
      type="button"
      className="collapse-map-button"
      onClick={onClick}
      data-cy="collapse-map"
    >
      <CollapseArrowIcon />
      <span>Collapse Map</span>
    </button>
  )
}

CollapseMapButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

// Drag handle + "Expand Map" button rendered at the top-left of the results
// header when the map is collapsed or partially expanded.
export function ExpandMapControls({ onExpand, onDragStart }) {
  return (
    <div className="expand-map-controls">
      <span
        className="map-resize-handle"
        role="separator"
        aria-orientation="vertical"
        aria-label="Drag to resize map"
        onMouseDown={onDragStart}
        onTouchStart={onDragStart}
        data-cy="map-resize-handle"
      >
        <DragDotsIcon />
      </span>
      <button
        type="button"
        className="expand-map-button"
        onClick={onExpand}
        data-cy="expand-map"
      >
        <MapGlyphIcon />
        <span>Expand Map</span>
      </button>
    </div>
  )
}

ExpandMapControls.propTypes = {
  onExpand: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
}
